import React, { useEffect, useRef, useCallback } from "react";
import styles from "./GalleryFolder.module.css";
import { GalleryImage } from "../ImagesDisplay/GalleryImage";

interface GalleryFolderProps {
  slides: GalleryImage[];
  description: string;
  onClick: () => void;
}

const GalleryFolder: React.FC<GalleryFolderProps> = ({
  slides,
  description,
  onClick,
}) => {
  const imageRefs = useRef<(HTMLImageElement | null)[]>([]);

  const setImageRef = useCallback(
    (el: HTMLImageElement | null, idx: number) => {
      imageRefs.current[idx] = el;
    },
    []
  );

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          img.src = img.dataset.src!;
          observer.unobserve(img);
        }
      });
    });

    imageRefs.current.forEach((img) => {
      if (img) {
        observer.observe(img);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const shuffleArray = (array: any) => {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ];
    }
    return shuffledArray;
  };
  const shuffledSlides = shuffleArray(slides);
  const selectedSlides = shuffledSlides.slice(0, 4);

  return (
    <div className={styles.section} onClick={onClick}>
      <div className={styles.thumbnails}>
        {selectedSlides.map((slide, idx) => (
          <img
            key={idx}
            ref={(el) => setImageRef(el, idx)}
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            data-src={slide.src}
            alt={slide.description}
            className={styles.thumbnail}
          />
        ))}
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default GalleryFolder;
